import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  text-align: center;
  color: #636980;

  .title {
    font-size: 22px;
    font-weight: 600;
    color: #1f243b;
    margin-bottom: 8px;
  }

  .subtitle {
    font-size: 15px;
    max-width: 360px;
  }
`;

const ComingSoon = ({ label = "This feature" }) => (
  <Wrapper>
    <p className="title">{label} is coming soon</p>
    <p className="subtitle">
      This section hasn't been built yet. Check back once it's ready.
    </p>
  </Wrapper>
);

export default ComingSoon;
